import { loadJSView } from './loadView';

// JS Views
const stripeCardForm = loadJSView('stripe/stripeCardForm');

const stripeViews = {
  stripeCardForm,
};

export default stripeViews;
